<template>
  <div class="criterio-input-integer">
    <span class="criterio-subtitle">{{ label }}</span>

    <v-layout class="container-cumpon-range">
      <v-flex class="d-flex" cols="12" sm="12">
        <v-text-field v-model="value" v-mask="inputMask" :disabled="disabled" solo hide-details :suffix="suffix" @input="input" @keypress="isNumber" />
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
export default {
  props: {
    label: String,
    currentIndex: Number,
    initialValue: {},
    values: {},
    componentParams: String,
    disabled: {
      type: Boolean,
      default: false,
    },
  },

  data: () => ({
    value: null,
  }),

  computed: {
    inputMask() {
      if (['age', 'percentage'].includes(this.componentParams)) return '###'
      else return '########'
    },
    suffix() {
      if (this.componentParams === 'percentage') return '%'
      return ''
    },
  },

  watch: {
    label: function () {
      this.value = null
    },
  },

  mounted() {
    this.getData()
  },

  methods: {
    hasValue(value) {
      return value !== ''
    },

    input() {
      window.clearTimeout(this.timeout)
      this.timeout = window.setTimeout(() => {
        this.$emit('input', { currentValue: Number(this.value), currentIndex: this.currentIndex })
        this.validate()
      }, 500)
    },

    async validate() {
      this.$emit('validate', { isValid: await this.isValid(), currentIndex: this.currentIndex })
    },

    isValid() {
      if (!this.hasValue(this.value)) return false
      return Number(this.value) >= 0
    },

    isNumber(evt) {
      evt = evt || window.event
      const charCode = evt.which ? evt.which : evt.keyCode
      if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 46) {
        evt.preventDefault()
      } else {
        return true
      }
    },

    getData() {
      if (this.initialValue) {
        this.value = this.initialValue
      }
      this.validate()
    },
  },
}
</script>

<style lang="scss">
.criterio-input-integer {
  .criterio-subtitle {
    font-size: 16px;
  }

  .container-cumpon-range {
    margin-top: 10px;

    p:nth-child(1) {
      margin-right: 15px;
    }
  }
}
</style>
